// Dependency-free leaf module for the profile boot fan-out guard.
//
// The profile / views / portal-scoped boot fan-out (APX-382 split it by portal:
// look-ups for coordinators, the request counter for vendors) must
// fire once per full-page session. The flag lives here — in a module with NO
// imports — so both `useUserProfile` (which imports `useAuth` from AuthContext)
// and the auth teardown surfaces (`AuthContext`, the 401 handler in
// `helper/api.ts`) can share it WITHOUT forming an import cycle.
//
// Previously the guard lived in `useUserProfile` and `AuthContext` imported it
// from there, creating the cycle AuthContext → useUserProfile → AuthContext.
// Under Jest that cycle surfaced as a temporal-dead-zone
// `ReferenceError: Cannot access 'AuthContext' before initialization`, which
// broke module initialization for every suite that transitively loaded it.
//
// Reset paths (must stay in sync with auth teardown):
//   - Full page reloads (login redirect) re-evaluate the module.
//   - `signOut` / `signOutAndClearOnly` in AuthContext call
//     `resetUserProfileBootGuard()`. `signOutAndClearOnly` does not hard-nav, so
//     that call is load-bearing there.
//   - The global 401 / session-expiry handler in `helper/api.ts` resets it after
//     the forced sign-out so a new same-tab session re-runs the boot fan-out.
//   - The `getProfile` .catch in `useUserProfile` resets it (via
//     `setBootFetchStarted(false)`) so a transient failure that falls through to
//     `doSyncUser` can retry the fan-out on the next mount.

let hasBootFetchStarted = false;

export const getBootFetchStarted = (): boolean => hasBootFetchStarted;

export const setBootFetchStarted = (value: boolean): void => {
  hasBootFetchStarted = value;
};

export const resetUserProfileBootGuard = (): void => {
  hasBootFetchStarted = false;
};
